import { _route, _latLngs, } from '../route-model/Route';
const _c_multipleRoutes = (latLngSeqs, $map) => {
    const createRouteWithMap = _routeWithMap($map);
    return latLngSeqs.map(createRouteWithMap);
}, _c_replacementRoutes = (existingRoutes, latLngSeqs, $map) => {
    const createRouteWithMap = _routeWithMap($map), newRoutes = latLngSeqs.map(createRouteWithMap);
    return {
        o: existingRoutes,
        n: newRoutes,
    };
}, _routeWithMap = ($map) => (latLngs) => _route(latLngs, $map), _c_reversedRoute = (route, $map) => {
    const latLngs = _latLngs(route.s(), route.e());
    latLngs.reverse();
    const reversedRoute = _route(latLngs, $map);
    return {
        o: route,
        n: reversedRoute,
    };
};
export { _c_multipleRoutes, _c_replacementRoutes, _c_reversedRoute, };
